function changeMap(e) {
    event.preventDefault();
    var newUrl = e.getAttribute("href");
    var mapFrame = document.getElementById("maps-banner");
    var mapTop = document.getElementById("maps-top");
    mapFrame.src = newUrl;
    mapTop.scrollIntoView();
}

require('./sticky-menu');
require('./counter');

import $ from 'jquery';

window.$ = window.jQuery = $;
import 'slick-carousel'
import Chocolat from 'chocolat'

// Allow jQuery-bound touch handlers (e.g. slick) to call preventDefault(),
// which requires non-passive listeners. Modern browsers default touchmove to
// passive, so without this slick cannot stop page scroll during horizontal swipes.
$.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener('touchstart', handle, { passive: true });
    }
};
$.event.special.touchmove = {
    setup: function (_, ns, handle) {
        this.addEventListener('touchmove', handle, { passive: false });
    }
};

require('./search-field');
require('./price-combobox');
require('./talq-block');


window.mediaLightbox = Chocolat(document.querySelectorAll('.media-lightbox'), {
    // options here
})

window.mapsLightbox = Chocolat(document.querySelectorAll('.maps-lightbox'), {
    // options here
})

window.videosLightbox = Chocolat(document.querySelectorAll('.videos-lightbox'), {
    // options here
})

require('./image-slider.js');

// Prevent null-reference crashes during slick's refresh/destroy cycle.
// Slick resets $list (and $slideTrack etc.) to null between destroy() and buildOut(),
// so any deferred setPosition call that lands in that window crashes with null reads
// in setDimensions, setCSS, setHeight, etc. Guarding setPosition itself stops all of
// them in one place.
// Slick.prototype is not exposed publicly, so we reach it through the first instance.
(function () {
    var _origSlick = $.fn.slick;
    var _patched = false;
    $.fn.slick = function () {
        var result = _origSlick.apply(this, arguments);
        if (!_patched && typeof arguments[0] !== 'string' && this.length && this[0].slick) {
            var proto = Object.getPrototypeOf(this[0].slick);

            var _origSetPosition = proto.setPosition;
            proto.setPosition = function () {
                if (!this.$list) return;
                _origSetPosition.apply(this, arguments);
            };

            var _origCheckResponsive = proto.checkResponsive;
            proto.checkResponsive = function () {
                if (this._checkingResponsive) return;
                this._checkingResponsive = true;
                try {
                    _origCheckResponsive.apply(this, arguments);
                } finally {
                    this._checkingResponsive = false;
                }
            };

            _patched = true;
        }
        return result;
    };
}());

$('.usp-slider').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 3,
    arrows: false,
    responsive: [
        {
            breakpoint: 1280,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1
            }
        }
    ]
});

$('.usp-slider-large').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 4,
    arrows: true,
    responsive: [
        {
            breakpoint: 1280,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1
            }
        }
    ]
});

$('.review-slider, .review-slider-nienaber').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 3,
    arrows: true,
    responsive: [
        {
            breakpoint: 1280,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1
            }
        }
    ]
});

$('.review-slider-nienaber').slick('slickSetOption', 'slidesToShow', 2, true);

$('.single-review-slider').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: true,
    responsive: [
        {
            breakpoint: 1280,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1
            }
        }
    ]
});


// change select placeholder color
$('select.input-lg').change(function () {
    if (!$(this).find(":selected").val()) {
        $(this).addClass('text-placeholder').removeClass('text-black');
    } else {
        $(this).removeClass('text-placeholder').addClass('text-black');
    }
});

$('.news-slider').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 3,
    arrows: true,
    responsive: [
        {
            breakpoint: 1280,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1
            }
        }
    ]
});

jQuery(function ($) {
    $(".mobile-menu-toggle").click(function () {
        var panel = $("#mobileMenu .slide-panel");
        var overlay = $("#mobileMenu .slide-background");

        if (!panel.hasClass('open')) {
            $("#mobileMenu").removeClass('hidden');
            setTimeout(function () {
                panel.toggleClass('translate-x-full open')
                overlay.toggleClass('opacity-0');
            }, 10);

            $('body').addClass('menu-open-body-overflow');
        } else {
            panel.toggleClass('translate-x-full open')
            overlay.toggleClass('opacity-0');

            setTimeout(function () {
                if (!panel.hasClass('open')) {
                    $("#mobileMenu").toggleClass('hidden')
                }
            }, 750);

            $('body').removeClass('menu-open-body-overflow');
        }
    });

    $(document).on('dragstart', '.chocolat-img', function (e) {
        e.preventDefault();
    });


    $(document).on('touchstart mousedown', '.chocolat-img', function (e) {
        let startX = e.pageX || e.originalEvent.touches[0].pageX;
        let startY = e.pageY || e.originalEvent.touches[0].pageY;
        let isMouse = e.type === 'mousedown';
        let threshold = 50;

        function handleMove(event) {
            let moveX = event.pageX || event.originalEvent.touches[0].pageX;
            let moveY = event.pageY || event.originalEvent.touches[0].pageY;

            let distX = moveX - startX;
            let distY = moveY - startY;

            if (Math.abs(distX) > Math.abs(distY) && Math.abs(distX) > threshold) {
                if (distX > 0) {
                    window.mediaLightbox.api.prev();
                } else {
                    window.mediaLightbox.api.next();
                }
                cleanup();
            }
        }

        function cleanup() {
            $(document).off('mousemove touchmove', handleMove);
            $(document).off('mouseup touchend', cleanup);
        }

        $(document).on(isMouse ? 'mousemove' : 'touchmove', handleMove);
        $(document).on(isMouse ? 'mouseup' : 'touchend', cleanup);
    });


    $('.media-lightbox-open').on('click', function () {
        window.mediaLightbox.api.open();
    });

    $('.maps-lightbox-open').on('click', function () {
        window.mapsLightbox.api.open();
    });

    $('.videos-lightbox-open').on('click', function () {
        window.videosLightbox.api.open();
    });
});

document.addEventListener("DOMContentLoaded", function () {
    let lazyImages = [].slice.call(document.querySelectorAll(".lazy-load"));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    let lazyImage = entry.target;
                    if (lazyImage.nodeName.toLowerCase() === "div") {
                        lazyImage.style.backgroundImage = 'url("' + lazyImage.dataset.src + '")';
                    } else {
                        lazyImage.src = lazyImage.dataset.src;
                    }

                    lazyImage.classList.remove("lazy-load");
                    lazyImageObserver.unobserve(lazyImage);

                }
            });
        });

        lazyImages.forEach(function (lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    } else {
        // Possibly fall back to a more compatible method here
    }
});

// Generic fly-in animation on view for any container with [data-flyin]
window.initFlyin = function (context) {
    var containers = (context || document).querySelectorAll('[data-flyin]:not(.anim-ready)');
    if (!containers.length) return;

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function reveal(container, items, delay, start) {
        container.classList.add('in-view');
        if (prefersReduced) {
            Array.prototype.forEach.call(items, function (el) {
                el.classList.add('in');
                el.classList.add('flyin-done');
            });
            return;
        }
        var revealDuration = 650; // ms, keep in sync with CSS
        var buffer = 60; // small safety buffer
        Array.prototype.forEach.call(items, function (el, i) {
            var t = start + i * delay;
            setTimeout(function () { el.classList.add('in'); }, t);
            setTimeout(function () { el.classList.add('flyin-done'); }, t + revealDuration + buffer);
        });
    }

    Array.prototype.forEach.call(containers, function (container) {
        container.classList.add('anim-ready');

        var itemsSelector = container.getAttribute('data-flyin-items') || '> *';
        var items = container.querySelectorAll(itemsSelector);

        // Add helper class so generic CSS can target items consistently
        Array.prototype.forEach.call(items, function (el) { el.classList.add('flyin-item'); });

        var threshold = parseFloat(container.getAttribute('data-flyin-threshold') || '0.05');
        var delay = parseInt(container.getAttribute('data-flyin-delay') || '120', 10);
        var start = parseInt(container.getAttribute('data-flyin-start') || '0', 10);

        // Observe every item individually rather than the whole container:
        // with many stacked items (e.g. a single-column grid on mobile) the
        // container can become far taller than the viewport, making a
        // container-relative threshold nearly impossible to reach. Observing
        // each item also means a page load that starts mid-list (e.g. after
        // a refresh) still reveals immediately, since IntersectionObserver
        // fires for targets that are already visible when observed.
        var revealed = false;

        function triggerReveal(obs) {
            if (revealed) return;
            revealed = true;
            reveal(container, items, delay, start);
            obs.disconnect();
        }

        if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(function (entries, obs) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        triggerReveal(obs);
                    }
                });
            }, { threshold: threshold });

            var observeTargets = items.length ? items : [container];
            Array.prototype.forEach.call(observeTargets, function (t) { io.observe(t); });
        } else {
            // Fallback: reveal immediately
            reveal(container, items, delay, start);
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    window.initFlyin();
});

// Back to top
$(window).scroll(function () {
    let scrollTop = $(window).scrollTop();
    let width = $(window).width();

    if (width < 768) {
        if (scrollTop > 100) {
            $('.back-to-top-link').fadeIn();
        } else {
            $('.back-to-top-link').fadeOut();
        }
    } else {
        $('.back-to-top-link').hide();
    }

});

$('.site-popup').each(function () {
    let popupId = $(this).attr('data-popup-id');
    if (popupId && document.cookie.indexOf("popup_" + popupId + "_hidden=") > -1) {
        $(this).remove();
    }
});


$('.close-site-popup').on('click', function () {
    let popupId = $(this).attr('data-popup-id');
    if (popupId) {
        document.cookie = "popup_" + popupId + "_hidden=yes;"
        $('.site-popup-' + popupId).remove();
    }

});


$("figure img").parent().addClass('bg-after-block');

$('#search-form-page-2-submit').click(function (event) {
    var places = $("#form-input-places option").map(function () {
        return this.value;
    }).get().join(",");

    var areas = $("#form-input-areas option").map(function () {
        return this.value;
    }).get().join(",");

    if (places === "" && areas === "") {
        event.preventDefault();
        var parent = document.getElementById('search-form-page-2-submit').parentNode;

        var tag = document.createElement('p');
        tag.classList = 'px-4 py-3 relative mb-4 font-bold';

        var text = document.createTextNode('Selecteer ten minste één plaats of gebied');
        tag.appendChild(text);
        parent.appendChild(tag);
    }
});

window.switchFaPlusMinus = function (element) {
    let faPlusElements = element.getElementsByClassName("fa-plus");
    for (let i = 0; i < faPlusElements.length; i++) {
        faPlusElements[i].classList.toggle('hidden');
    }

    let faMinElements = element.getElementsByClassName("fa-minus");
    for (let i = 0; i < faMinElements.length; i++) {
        faMinElements[i].classList.toggle('hidden');
    }
}
